<template>
  <div
    ref="columnRoot"
    v-editable
    class="flex flex-none flex-col gap-5 px-[20px] pb-[24px] pt-[44px]"
    style="width: 16rem"
  >
    <NavigationItem
      v-for="item in mainNavigationMatch"
      :key="item._uid"
      :blok="item"
      @click="onClick(item, $event)"
    />
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import useUiState from '~/composables/ui/useUiState'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type { SbNavigationItem } from '~/cms/storyblok/types/storyblok.d.ts'

defineProps({
  mainNavigationMatch: {
    type: Array as PropType<SbNavigationItem[]>,
    default: () => [],
  },
})

const emit = defineEmits(['register-column'])
const { trackNavigationFlyout } = useTrackingEvents()
const { closeFlyoutMenu } = useUiState()
const columnRoot = ref(null)

const onClick = (item: SbNavigationItem, event: MouseEvent) => {
  if (item.label) trackNavigationFlyout(item.label, 2)

  closeFlyoutMenu(event, true)
}

onMounted(() => {
  emit('register-column', columnRoot.value)
})
</script>
